// extracted by mini-css-extract-plugin
module.exports = {"content":"title6Bento_content__KR0xZ","titles":"title6Bento_titles__zYI2l","bodies":"title6Bento_bodies__atdfR","buttonGroup":"title6Bento_buttonGroup__V7UP5"};